import './LanguageSelector.scss';

import { DownOutlined } from '@ant-design/icons';
import { useGetLocale, useSetLocale } from '@refinedev/core';
import { Avatar, Button, Dropdown, Flex, MenuProps } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { setDayjsLocale } from '@/dayjs.config';
import en_flag from '@/img/en.svg';
import es_flag from '@/img/es.svg';
import pt_flag from '@/img/pt.svg';

const LanguageSelector = () => {
  const { t, i18n } = useTranslation();
  const locale = useGetLocale();
  const changeLanguage = useSetLocale();
  const currentLocale = locale();
  const menuItems: MenuProps['items'] = [...(i18n.languages || [])]
    .sort((v1, v2) => v1.localeCompare(v2))
    .map((lang: string) => ({
      key: lang,
      onClick: () => {
        changeLanguage(lang);
        setDayjsLocale(lang);
      },
      icon: (
        <span style={{ marginRight: 8 }}>
          <Avatar size={16} src={lang == 'es' ? es_flag : lang == 'pt' ? pt_flag : en_flag} />
        </span>
      ),
      label: lang === 'es' ? t('Español') : lang === 'pt' ? t('Portugués') : t('Ingles'),
    }));

  useEffect(() => {
    if (currentLocale) {
      setDayjsLocale(currentLocale);
    }
  }, [currentLocale]);

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items: menuItems,
        selectedKeys: currentLocale ? [currentLocale] : [],
      }}>
      <Button type="text" className="LanguageSelector" style={{ padding: 0 }}>
        <Flex align="center" gap={4}>
          <Avatar
            size={16}
            src={currentLocale == 'es' ? es_flag : currentLocale == 'pt' ? pt_flag : en_flag}
          />
          {currentLocale === 'es'
            ? t('Español')
            : currentLocale === 'pt'
              ? t('Portugués')
              : t('Ingles')}
          <DownOutlined />
        </Flex>
      </Button>
    </Dropdown>
  );
};

export default LanguageSelector;
